import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import RegistrationLink from './RegistrationLink.vue'

export default [
    { path: '/registration-link', component: RegistrationLink, beforeEnter: AdminGuard, name: 'registrationLink', meta: { title: 'Link Pendaftaran' } },
]
